import { PluginToolbarId } from './plugin-toolbar-id';

export const PluginNameToToolbarIdMap = {
  ACTION_BUTTON: PluginToolbarId.actionButton,
  LINK_BUTTON: PluginToolbarId.linkButton,
  LINK: PluginToolbarId.link,
  ANCHOR: PluginToolbarId.link,
  VIDEO: PluginToolbarId.video,
  DIVIDER: PluginToolbarId.divider,
  FILE: PluginToolbarId.file,
  GALLERY: PluginToolbarId.gallery,
  GIF: PluginToolbarId.gif,
  HTML: PluginToolbarId.html,
  IMAGE: PluginToolbarId.image,
  LINK_PREVIEW: PluginToolbarId.linkPreview,
  POLL: PluginToolbarId.poll,
  EMBED: PluginToolbarId.embed,
  APP_EMBED: PluginToolbarId.appEmbed,
  COLLAPSIBLE_LIST: PluginToolbarId.collapsibleList,
  COLLAPSIBLE_ITEM: PluginToolbarId.collapsibleList,
  COLLAPSIBLE_ITEM_TITLE: PluginToolbarId.collapsibleList,
  COLLAPSIBLE_ITEM_BODY: PluginToolbarId.collapsibleList,
  TABLE: PluginToolbarId.table,
  TABLE_CELL: PluginToolbarId.table,
  TABLE_ROW: PluginToolbarId.table,
  AUDIO: PluginToolbarId.audio,
  LAYOUT: PluginToolbarId.layout,
  LAYOUT_CELL: PluginToolbarId.layoutCell,
} as const;
